import { css } from '@emotion/react'
import Label from './Label'
import Row from './IndentedRow'
import RecipientsEditor from './RecipientsEditor'

const flexStyle = css`
  flex: 1 0 100%;
`

const BccRow = ({ className, ...rest }) => {
  const { ticketId, onUpdate } = rest
  return (
    <Row css={flexStyle} className={className}>
      <Label>BCC:</Label>
      <RecipientsEditor
        key={`recipientseditor-bcc-${ticketId}`}
        className="grui ml-3"
        type="bcc"
        onUpdateCustom={onUpdate}
        {...rest}
      />
    </Row>
  )
}

export default BccRow
